import React, { useState } from "react";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function CSVuploadQuery90({ setPopUpWindow }) {
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [fonteOrdine, setFonteOrdine] = useState("VIG");
  const [risultatoOperazione, setRisultatoOperazione] = useState(
    "In attesa dell'upload",
  );

  const { tastoChiudiAspetto } = stilePulsanti;

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const handleSubmission = () => {
    const formData = new FormData();

    formData.append("uploaded_file", selectedFile);
    formData.append("fonte_ordine", fonteOrdine);

    fetch(apiUrl + "/logistica/csv/90", {
      method: "POST",
      body: formData,
    })
      .then((result) => {
        setRisultatoOperazione("Dati caricati correttamente");
        console.log("Success:", result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <div className="pa4">
      {setPopUpWindow && (
        <button
          className="dim tastoInputOrizzontale br3"
          onClick={(e) => {
            e.preventDefault();
            setPopUpWindow(false);
          }}
        >
          {tastoChiudiAspetto}
        </button>
      )}
      <h1>Query 90</h1>
      <p>
        Importa i risultati ottenuti dalla query 90 su prestashop, accetta il
        csv scaricato direttamente da ps
      </p>
      <label className="db mb2">
        Fonte dell'ordine:
        <select
          className="db mt1 pa2 br2"
          value={fonteOrdine}
          onChange={(e) => setFonteOrdine(e.target.value)}
        >
          <option value="VIG">VIG</option>
          <option value="BOT">BOT</option>
        </select>
      </label>
      <input type="file" accept="csv" name="file" onChange={changeHandler} />
      {isFilePicked ? (
        <div>
          <p>Nome del file: {selectedFile.name}</p>
          <p>Tipo file: {selectedFile.type}</p>
          <p>Dimensione in bytes: {selectedFile.size}</p>
          <p>
            Data ultima modifica:{" "}
            {selectedFile.lastModifiedDate.toLocaleDateString()}
          </p>
        </div>
      ) : (
        <p>Seleziona un file</p>
      )}
      <div>
        <button
          onClick={handleSubmission}
          className="f6 link dim ba b--dark-green ph3 pv2 mt4 dib white bg-dark-green br3 mr2 w-70 center"
        >
          Carica
        </button>
      </div>
      <p>{risultatoOperazione}</p>
    </div>
  );
}

export default CSVuploadQuery90;
